import { CartLinesUpdateEvent, CartErrorEvent } from '@shopify/events';

if (!window.__onovoRoutineBannerReady) {
  window.__onovoRoutineBannerReady = true;
  const reduceMotion = () => matchMedia('(prefers-reduced-motion: reduce)').matches;
  const cards = (section) => Array.from(section.querySelectorAll('.ow-routine-banner__card'));

  function updateCarousel(section) {
    const track = section.querySelector('[data-routine-track]');
    if (!track || !section.classList.contains('ow-routine-banner--slider')) return;
    const list = cards(section);
    const gap = parseFloat(getComputedStyle(track).columnGap) || 0;
    const step = (list[0]?.getBoundingClientRect().width || 1) + gap;
    const current = Math.min(list.length - 1, Math.max(0, Math.round(track.scrollLeft / step)));
    const counter = section.querySelector('[data-routine-counter]');
    if (counter) counter.textContent = String(current + 1).padStart(2, '0') + ' / ' + list.length;
    const prev = section.querySelector('[data-routine-prev]');
    const next = section.querySelector('[data-routine-next]');
    if (prev) prev.disabled = track.scrollLeft < 3;
    if (next) next.disabled = track.scrollLeft >= track.scrollWidth - track.clientWidth - 3;
  }

  async function addRoutine(section, button) {
    if (button.disabled) return;
    const status = section.querySelector('[data-routine-status]');
    const label = section.querySelector('[data-routine-label]');
    const original = label.textContent;
    let items;
    try { items = JSON.parse(section.querySelector('[data-routine-items]')?.textContent || '[]'); }
    catch { items = []; }
    if (!items.length || items.some((item) => !item.id)) return;
    button.disabled = true;
    button.classList.add('is-loading');
    label.textContent = 'Po shtohet rutina…';
    if (status) {
      status.textContent = '';
      status.classList.remove('is-error');
    }
    const deferred = CartLinesUpdateEvent.createPromise();
    section.dispatchEvent(new CartLinesUpdateEvent({
      action: 'add',
      context: 'product',
      lines: items.map((item) => ({ merchandiseId: String(item.id), quantity: item.quantity })),
      promise: deferred.promise,
    }));
    try {
      const components = Array.from(document.querySelectorAll('cart-items-component'));
      const sections = components.map((component) => component.dataset.sectionId).filter(Boolean).join(',');
      const response = await fetch(window.Theme?.routes?.cart_add_url || '/cart/add.js', {
        method: 'POST',
        credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items, sections }),
      });
      const result = await response.json();
      if (!response.ok || result.status) throw new Error(result.description || result.message || 'Rutina nuk u shtua. Provo përsëri.');
      let cart;
      const component = document.querySelector('cart-items-component');
      if (component) {
        await customElements.whenDefined('cart-items-component');
        cart = await component.fetchCartData();
      } else {
        const cartResponse = await fetch((window.Theme?.routes?.cart_url || '/cart') + '.json', { credentials: 'same-origin' });
        if (!cartResponse.ok) throw new Error('Shporta nuk u përditësua.');
        cart = await cartResponse.json();
      }
      deferred.resolve({
        cart: CartLinesUpdateEvent.createCartFromAjaxResponse(cart),
        detail: {
          items: cart.items,
          source: 'onovo-routine-banner',
          sourceId: section.id,
          itemCount: items.length,
          sections: result.sections,
          didError: false,
        },
      });
      if (status) status.textContent = 'Rutina u shtua në shportë.';
    } catch (error) {
      deferred.reject(error);
      section.dispatchEvent(new CartErrorEvent({ error: error.message, code: 'INVALID' }));
      if (status) {
        status.classList.add('is-error');
        status.textContent = error.message || 'Rutina nuk u shtua. Provo përsëri.';
      }
    } finally {
      button.disabled = false;
      button.classList.remove('is-loading');
      label.textContent = original;
    }
  }

  document.addEventListener('click', (event) => {
    const control = event.target.closest('[data-routine-prev], [data-routine-next], [data-routine-add]');
    if (!control) return;
    const section = control.closest('[data-routine-banner]');
    if (!section) return;
    if (control.hasAttribute('data-routine-add')) { addRoutine(section, control); return; }
    const track = section.querySelector('[data-routine-track]');
    const gap = parseFloat(getComputedStyle(track).columnGap) || 0;
    const step = (cards(section)[0]?.getBoundingClientRect().width || 0) + gap;
    track.scrollBy({ left: (control.hasAttribute('data-routine-prev') ? -1 : 1) * step, behavior: reduceMotion() ? 'instant' : 'smooth' });
  });
  document.addEventListener('scroll', (event) => {
    if (event.target.matches?.('[data-routine-track]')) updateCarousel(event.target.closest('[data-routine-banner]'));
  }, true);
  window.addEventListener('resize', () => document.querySelectorAll('[data-routine-banner]').forEach(updateCarousel));
  document.addEventListener('shopify:section:load', (event) => event.target.querySelectorAll('[data-routine-banner]').forEach(updateCarousel));
  document.querySelectorAll('[data-routine-banner]').forEach(updateCarousel);
}
